import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "price-override-container",
        { "price-locked--unsaved": _vm.hasUnsavedKpiResults },
        { "price-locked--disabled": !_vm.isPriceOverrideEditable },
      ],
    },
    [
      ((_vm.hasOverrideHandle || _vm.isSmartOverrideHandle) &&
        !_vm.isActiveTransitionPeriodOverrideHandle) ||
      _vm.item.recalculatingKPIs
        ? _c(
            "div",
            { staticClass: "revert-button-container" },
            [
              _c(
                VBtn,
                {
                  staticClass: "revert-button",
                  class: [
                    _vm.hasUnsavedKpiResults ? "unsaved-kpis" : "",
                    !_vm.isPriceOverrideEditable
                      ? "unsaved-kpis--readonly"
                      : "",
                  ],
                  attrs: {
                    small: "",
                    depressed: "",
                    icon: "",
                    loading: _vm.item.recalculatingKPIs,
                    disabled:
                      _vm.item.recalculatingKPIs ||
                      !_vm.isPriceOverrideEditable,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleRevert.apply(null, arguments)
                    },
                  },
                },
                [_vm._m(0)],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isActiveTransitionPeriodOverrideHandle
        ? _c(
            VIcon,
            {
              staticClass: "transition-period-override",
              attrs: { "x-small": "" },
            },
            [_vm._v("fa fa-snowflake-o")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "price-container" }, [
        _c(
          "div",
          {
            class: {
              "price-value": true,
              "transition-period-override":
                _vm.isActiveTransitionPeriodOverrideHandle,
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.formattedPriceValue) + "\n    ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { attrs: { "x-small": "", dark: "" } }, [
      _vm._v("fa fa-undo"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }